(()=>{
    const link = document.getElementById("app-css");
    if (!link) return;
    const enable = ()=>{
        link.media = "all";
    };
    if (link.sheet) enable();
    else link.addEventListener("load", enable, {
        once: true
    });
})();

//# sourceMappingURL=index.fe19a8da.js.map
